var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60229 15.1367C9.41029 15.1367 9.21829 15.0637 9.07229 14.9167C8.77929 14.6237 8.77929 14.1497 9.07229 13.8567L13.8643 9.06472C14.1573 8.77172 14.6313 8.77172 14.9243 9.06472C15.2173 9.35772 15.2173 9.83172 14.9243 10.1247L10.1323 14.9167C9.98629 15.0637 9.79429 15.1367 9.60229 15.1367Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3963 15.1395C14.2043 15.1395 14.0123 15.0665 13.8663 14.9195L9.07034 10.1225C8.77734 9.82952 8.77734 9.35552 9.07034 9.06252C9.36434 8.76952 9.83834 8.76952 10.1303 9.06252L14.9263 13.8595C15.2193 14.1525 15.2193 14.6265 14.9263 14.9195C14.7803 15.0665 14.5873 15.1395 14.3963 15.1395Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSquare);
export default __webpack_public_path__ + "static/media/CloseSquare.1e3d28ab35e1c2083eccc11b0baca66c.svg";
export { ForwardRef as ReactComponent };